export enum BioSampleStatusType {
  COLLECTION = 'COLLECTION',
  PROCESSING = 'PROCESSING',
  SHIPPING = 'SHIPPING',
  DELIVERY_LAB = 'DELIVERY_LAB',
  STORAGE_COMPLIANCE = 'STORAGE_COMPLIANCE',
  PROCESS_COMPLIANCE = 'PROCESS_COMPLIANCE',
  SHIPPING_NUMBER = 'SHIPPING_NUMBER',
  SAMPLE_TYPE = 'SAMPLE_TYPE',
  PROCESSED_SAMPLE_TYPE = 'PROCESSED_SAMPLE_TYPE',
  ANALYTE_TYPE = 'ANALYTE_TYPE',
  COMMENT = 'COMMENT',
}
